<!--
  - Copyright (c) 2022.
  - ISNLab
  - Owner and rewriter: Sedov A. Sergey
  - sedov.sergey@isnlab.com
  -->

<template>
  <footer class="app-footer">
    <div class="container text-center py-3">
      <small>&copy; RomanceNet</small>
    </div>
  </footer><!--//app-footer-->
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "FooterBlock"
}
</script>

<style scoped>

</style>